import { useEffect, useRef, useState } from "react";
import { api, API } from "@/lib/api";

// Live KPI summary. Built-in dataset streams via WebSocket; custom datasets poll REST.
export function useLiveSummary(filters, datasetId = "builtin") {
  const [summary, setSummary] = useState([]);
  const [live, setLive] = useState(false);
  const [tick, setTick] = useState(0);
  const pollRef = useRef(null);

  useEffect(() => {
    let closed = false;
    const builtin = datasetId === "builtin";
    const summaryUrl = builtin ? "/metrics/summary" : `/datasets/${datasetId}/summary`;
    const params = builtin ? filters : { range: filters.range };

    const fetchREST = () =>
      api.get(summaryUrl, { params })
        .then((r) => { if (!closed) setSummary(r.data); })
        .catch((e) => { if (!closed) console.debug("live summary fetch failed:", e?.message); });
    fetchREST();

    const startPoll = () => {
      if (pollRef.current) return;
      pollRef.current = setInterval(fetchREST, 5000);
    };
    const stopPoll = () => {
      if (pollRef.current) { clearInterval(pollRef.current); pollRef.current = null; }
    };

    let ws;
    if (builtin) {
      try {
        const wsBase = API.replace(/^http/, "ws");
        const qs = new URLSearchParams(filters).toString();
        ws = new WebSocket(`${wsBase}/ws/stream?${qs}`);
        ws.onopen = () => { if (!closed) { setLive(true); stopPoll(); } };
        ws.onmessage = (e) => {
          try {
            const msg = JSON.parse(e.data);
            if (msg.type === "summary" && !closed) setSummary(msg.data);
          } catch (err) { console.debug("ws message parse failed:", err?.message); }
        };
        ws.onclose = () => { if (!closed) { setLive(false); startPoll(); } };
        ws.onerror = () => { if (!closed) { setLive(false); startPoll(); } };
      } catch (_) {
        startPoll();
      }
    } else {
      setLive(false);
      startPoll();
    }

    const chartTimer = setInterval(() => setTick((t) => t + 1), 10000);

    return () => {
      closed = true;
      clearInterval(chartTimer);
      stopPoll();
      try { ws && ws.close(); } catch (err) { console.debug("ws close failed:", err?.message); }
    };
    // eslint-disable-next-line
  }, [JSON.stringify(filters), datasetId]);

  return { summary, tick, live };
}
